import { useAuth } from 'modules/auth/hooks/useAuth';

import { useFetchReferrerQuery } from '../actions/fetchReferrer';

export const useReferrer = () => {
  const { isLoggedIn } = useAuth();

  return useFetchReferrerQuery(undefined, { skip: !isLoggedIn });
};
